export default Object.freeze({
  Brown: 'brown',
  GreenLight: 'green-light',
  Yellow: 'yellow',
  Purple: 'purple',
  Violet: 'violet',
  Gray: 'gray',
});
